import { inject } from '@angular/core';
import { CanActivateChildFn, Router, UrlTree } from '@angular/router';

export const bestCourseGuard: CanActivateChildFn = async (route, state) => {
  const router = inject(Router);
  const params = collectAllParams(route);

  const continent = normalize(params['continent']);
  const country = normalize(params['country']);
  const stateName = normalize(params['state']);

  try {
    // ✅ 1️⃣ No params → allow 'world' route
    if (!continent && !country && !stateName) {
      return true;
    }

    // ✅ 2️⃣ Validate Continent
    const { staticCountry } = await import('./../services/countryList');
    const continentData = staticCountry.find(c => normalize(c.continent) === continent);
    if (!continentData) return redirect(router);

    // ✅ 3️⃣ Validate Country (if present)
    if (country) {
      if(country === 'great-britain-&-ireland') return true; // Special case for GB & Ireland
      const countryData = continentData.country.find(c => normalize(c.country) === country);
      if (!countryData) return redirect(router);

      // ✅ 4️⃣ Validate State (only for USA)
      if (stateName) {
        if (continent === 'north-america' && country === 'united-states-of-america') {
          const { stateList } = await import('./../services/stateList');
          const validState = stateList.some(s => normalize(s.stateFull) === stateName);
          if (!validState) return redirect(router);
        } else {
          return redirect(router);
        }
      }
    }

    return true;
  } catch (err) {
    console.error('bestCourseGuard error:', err);
    return redirect(router);
  }
};

// ✅ Reusable helpers

function collectAllParams(route: any): Record<string, string> {
  let params: Record<string, string> = { ...route.params };
  let parent = route.parent;
  while (parent) {
    params = { ...parent.params, ...params }; // Merge params from parent
    parent = parent.parent;
  }
  return params;
}

function normalize(value?: string): string {
  return (value ?? '').toLowerCase().replaceAll(' ', '-');
}

function redirect(router: Router): UrlTree {
  return router.createUrlTree(['/404']);
}
